const userConstants = {
  CHANGE_PASSWORD: 'CHANGE_PASSWORD',
  RELOAD: 'RELOAD',
  UPDATE_USER: 'UPDATE_USER',
  GET_USER_BY_REGISTRATION_TOKEN: 'GET_USER_BY_REGISTRATION_TOKEN'
};

export default userConstants;
